import Http from "@/utils/httpRequest";
const axios = new Http();

export default {
  importGcjsxmxx: (data) => {
    //导入项目
    return axios.post("/gcjsxm/public/importGcjsxmxx", data);
  },
  deleteGcjsxmxx: (data) => {
    //删除项目
    return axios.post("/gcjsxm/public/delete", data);
  },
  getComponentConfig: (data) => {
    //项目委托-包含说明，基本信息等
    return axios.post("/onlineServiceProject/public/getComponentConfig", data);
  },
  lookupDict: (data) => {
    //字典
    return axios.get("/common/public/lookupDict", data);
  },
  getContractListByChdwUserid: (data) => {
    //根据userid获取合同列表
    return axios.post("/htba/public/getContractListByChdwUserid", data);
  },
  getMappingUnitList: (data) => {
    //测绘单位列表
    return axios.post("/applet/wtsx/public/getCompanyList", data);
  },
  getCommitment: (data) => {
    //测绘服务事项列表
    return axios.get("/onlineServiceProject/public/getCommitment", data);
  },
  getDataByTemporarilyToCode: (data) => {
    //获取更改委托信息
    return axios.get(
      "/onlineServiceProject/public/getDataByTemporarilyToCode",
      data
    );
  },
  materialUpload: (data, onUploadProgress) => {
    //合同上传
    return axios.post("/onlineServiceProject/public/materialUpload", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: onUploadProgress,
    });
  },

  submitEntrust: (data) => {
    return axios.post("/onlineServiceProject/public/submitEntrust", data);
  },
  //委托卡片列表（包含了说明书）
  getAppointCard: () => {
    return axios.get("/applet/wtsx/public/getXmwtCard");
  },
  //项目信息
  getBaseComponentConfig: () => {
    return axios.get("/applet/wtsx/public/getBaseComponentConfig");
  },
  //测量事项
  getSurveyItemList: (data) => {
    return axios.post("/applet/wtsx/public/getSurveyItemList", data);
  },
  //材料上传
  getProvideFileList: (data) => {
    return axios.post("/applet/wtsx/public/getProvideFileList", data);
  },
  //根据项目代码调取项目信息
  getGGProjectInfo: (data) => {
    return axios.get("/onlineServiceProject/public/getGGProjectInfo", data);
  },

  // 2022-10-14
  // 获取需要材料上传列表
  getAppointProvideFileList: (data) => {
    return axios.post("/onlineServiceProject/public/getProvideFileList", data);
  },
  // 材料库选择
  getHistoryMaterial: (data) => {
    return axios.post("/onlineServiceProject/dchy/public/getHistoryMaterial",data);
  },
  // 项目委托提交
  submitAppointEntrust: (data) => {
    return axios.post("/onlineServiceProject/public/submitEntrust", data);
  },
  // 获取委托事项
  getItemWithNote: (data) => {
    return axios.get("/onlineServiceProject/public/getItemWithNote", data);
  },
};
